import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export function NotFoundPage() {
  return (
    <main className="flex min-h-screen items-center justify-center px-4">
      <div className="text-center">
        <p className="text-sm font-medium text-muted-foreground">
          404
        </p>
        <h1 className="mt-2 text-3xl font-semibold tracking-[-0.02em]">Page not found</h1>
        <p className="mt-2 text-muted-foreground">
          The requested route is not part of this foundation scaffold.
        </p>
        <Button asChild className="mt-6">
          <Link to="/">Return home</Link>
        </Button>
      </div>
    </main>
  );
}
